import $ from "jquery";
import "jquery-validation";
import "magnific-popup";

$( document ).ready(function() {

    // Donation Form variable
    var $form = $("#give-form");

    // Validate donation form
    var validator = $form.validate();

    // Recurring Radio Button Click
    var radioStatus="";
    $("input[type='radio']:checked").each(function(event)
    { 
        if ($(this).attr('checked'))
            radioStatus = $(this).data('label-recurring');
        $(".recurring-copy").text(radioStatus);
    });

    $("input[type='radio']").change(function(event)  
    {
        radioStatus = $('input[type="radio"]:checked').data('label-recurring');
        $('.recurring-copy').text(radioStatus);  
    });

    // Donate button click
    $('.give-button').on('click', function(event) 
    {
        event.preventDefault();

        // Scroll to the donation form
        var target = $('#give');

        $('html, body').animate({
            scrollTop: target.offset().top
        }, 300, function() { });
    });

    // Amount options
    $('input[type=radio][name=amount_option]').change(function() {
        let amount = this.value;
        if ( amount > 0)
        {
            $('input[name=amount]').val(amount);
        }
        else
        {
            $('input[name=amount]').val('').focus();
        }
    });

    // Handle give submit
    $('#give-form').submit(function(e) 
    {
        e.preventDefault();

        if ( $(this).valid() )
        {

            // Disable the submit button
            $("#give-submit").prop('disabled', true);

            // Add the spinner
            $("#give-submit-label").addClass('spinner');

            // Get the Stripe Captcha response
            var $stripeCaptchaResponse = $("#stripe-captcha-response");

            // console.log($("#captcha-response").val())
            if ( $stripeCaptchaResponse.val() == "" )
            {
                grecaptcha.execute(stripeCaptcha);
            }
            else
            {

                // Get form type
                var form_type = $('input[name=form_type]').val();

                // Get amount
                var amount = $('.give-amount').val();
                if ( amount !== undefined )
                {
                    amount = amount.replace(/\$/g, '').replace(/\,/g, '');
                    amount = parseFloat(amount);
                    if (isNaN(amount)) 
                    {
                        amount = 25;
                        $('.give-amount').val(25);
                    }
                    else if (amount < 5) 
                    {
                        amount = 5;
                        $('.give-amount').val(5);
                    }
                    amount = amount * 100; // Needs to be an integer!
                }

                // Get frequency
                var frequency = 'single';
                if ( form_type == 'monthly_only' || form_type == 'single_only' )
                {
                    frequency = $('input[name=frequency]').val();
                }
                else
                {
                    frequency = $('input[name=frequency]:checked').val();
                }
                
                // Ensure a valid frequency value
                if ( frequency != 'monthly' )
                    frequency = 'single';

                // Get the frequency description
                var desc = 'Single Gift';
                if ( frequency == 'monthly' )
                    desc = 'Monthly Gift';

                // Start Stripe Checkout
                $.ajax({
                    type: "POST",
                    url: "/donate.php",
                    data: $('#give-form').serialize(),
                    dataType: "json",
                    success: function(res)
                    {

                        /*
                            Example result:
                            session response: stdClass Object
                            (
                                [session_id] => cs_test_dWnrzGc80UUMyzdUwcvcgYG1rXxCStN6XxOgH2IJi2kvQMexjkqVVXiX
                            )
                        */

                        if ( res.success == 1 )
                        {
                            // Send the token to your server.
                            stripe.redirectToCheckout({
                                // Make the id field from the Checkout Session creation API response
                                // available to this file, so you can provide it as parameter here
                                // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                                sessionId: res.session_id
                            }).then(function (result) {
                                // If `redirectToCheckout` fails due to a browser or network
                                // error, display the localized error message to your customer
                                // using `result.error.message`.
                                $(".err-msg p").text(result.error.message);
                                $(".err-msg").addClass('show');
                            });            
                        }
                        else
                        {
                            // Show the error message
                            if ( res.message )
                            {
                                $(".err-msg p").text(res.message);
                            }
                            else
                            {
                                $(".err-msg p").text("There was a problem connecting to the payment page. Please try again.");
                            }
                            $(".err-msg").addClass('show');

                            // Re-enable the submit button
                            $("#give-submit").prop('disabled', false);

                            // Remove the spinner
                            $("#give-submit-label").removeClass('spinner');                            
                        }
                      
                    },
                    error: function(xhr)
                    {
                        // Show error message
                        $(".err-msg p").text("There was a problem: " + xhr.status + " " + xhr.statusText);
                        $(".err-msg").addClass('show');                        

                        // Re-enable the submit button
                        $("#give-submit").prop('disabled', false);

                        // Remove the spinner
                        $("#give-submit-label").removeClass('spinner');   
                    }
                });
            }
        }
    });      

    $(window).on('popstate', function() {
        handler.close();
    }); 

});

window.onLoadCallback = function()
{
    // Stripe Captcha
    window.stripeCaptcha = grecaptcha.render('stripe-captcha', { 
        sitekey: '6Ldec6YZAAAAAPI05HbmL41JsseuxMIo-0LUpr7b', 
        size: "invisible",
        badge: "inline",
        callback: onStripeSubmit
    });        
}

window.onStripeSubmit = function(response)
{

  //   // Trigger submit
  //   // var response = grecaptcha.getResponse();
    document.getElementById('stripe-captcha-response').value = response;  
    $("#give-form").trigger('submit');

}